import FrontendDeveloperPage from "./FrontendDeveloperPage";

export default function ServiceNowDeveloperPage() {
  return <FrontendDeveloperPage technology="servicenow" />;
}
